/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineServiceKindDto } from './traveline-service-kind-dto';
import {
    TravelineServiceKindDtoFromJSON,
    TravelineServiceKindDtoFromJSONTyped,
    TravelineServiceKindDtoToJSON,
    TravelineServiceKindDtoToJSONTyped,
} from './traveline-service-kind-dto';
import type { TravelineResourceDto } from './traveline-resource-dto';
import {
    TravelineResourceDtoFromJSON,
    TravelineResourceDtoFromJSONTyped,
    TravelineResourceDtoToJSON,
    TravelineResourceDtoToJSONTyped,
} from './traveline-resource-dto';
import type { TravelineVatDto } from './traveline-vat-dto';
import {
    TravelineVatDtoFromJSON,
    TravelineVatDtoFromJSONTyped,
    TravelineVatDtoToJSON,
    TravelineVatDtoToJSONTyped,
} from './traveline-vat-dto';
import type { TravelineEntityStateDto } from './traveline-entity-state-dto';
import {
    TravelineEntityStateDtoFromJSON,
    TravelineEntityStateDtoFromJSONTyped,
    TravelineEntityStateDtoToJSON,
    TravelineEntityStateDtoToJSONTyped,
} from './traveline-entity-state-dto';

/**
 * Description of the service provided by the property<br />
 * If ‘kind’=Meal, the meal plan code is specified in mealPlanCode field, otherwise mealPlanCode=null
 * @export
 * @interface TravelineServiceInfoDto
 */
export interface TravelineServiceInfoDto {
    /**
     * Service ID
     * @type {string}
     * @memberof TravelineServiceInfoDto
     */
    id: string;
    /**
     * Service name
     * @type {string}
     * @memberof TravelineServiceInfoDto
     */
    name: string;
    /**
     * Service description
     * @type {string}
     * @memberof TravelineServiceInfoDto
     */
    description?: string | null;
    /**
     * 
     * @type {TravelineServiceKindDto}
     * @memberof TravelineServiceInfoDto
     */
    kind: TravelineServiceKindDto;
    /**
     * Meal plan code. Specified in case the service type is ‘Meal’ (Kind = Meal)
     * @type {string}
     * @memberof TravelineServiceInfoDto
     */
    mealPlanCode?: string | null;
    /**
     * Meal plan name. Specified in case the service type is ‘Meal’ (Kind = Meal)
     * @type {string}
     * @memberof TravelineServiceInfoDto
     */
    mealPlanName?: string | null;
    /**
     * Array of images of the service provided
     * @type {Array<TravelineResourceDto>}
     * @memberof TravelineServiceInfoDto
     */
    images?: Array<TravelineResourceDto> | null;
    /**
     * 
     * @type {TravelineEntityStateDto}
     * @memberof TravelineServiceInfoDto
     */
    status?: TravelineEntityStateDto;
    /**
     * 
     * @type {TravelineVatDto}
     * @memberof TravelineServiceInfoDto
     */
    vat?: TravelineVatDto;
}



/**
 * Check if a given object implements the TravelineServiceInfoDto interface.
 */
export function instanceOfTravelineServiceInfoDto(value: object): value is TravelineServiceInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function TravelineServiceInfoDtoFromJSON(json: any): TravelineServiceInfoDto {
    return TravelineServiceInfoDtoFromJSONTyped(json, false);
}

export function TravelineServiceInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineServiceInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'kind': TravelineServiceKindDtoFromJSON(json['kind']),
        'mealPlanCode': json['mealPlanCode'] == null ? undefined : json['mealPlanCode'],
        'mealPlanName': json['mealPlanName'] == null ? undefined : json['mealPlanName'],
        'images': json['images'] == null ? undefined : ((json['images'] as Array<any>).map(TravelineResourceDtoFromJSON)),
        'status': json['status'] == null ? undefined : TravelineEntityStateDtoFromJSON(json['status']),
        'vat': json['vat'] == null ? undefined : TravelineVatDtoFromJSON(json['vat']),
    };
}

  export function TravelineServiceInfoDtoToJSON(json: any): TravelineServiceInfoDto {
      return TravelineServiceInfoDtoToJSONTyped(json, false);
  }

  export function TravelineServiceInfoDtoToJSONTyped(value?: TravelineServiceInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'kind': TravelineServiceKindDtoToJSON(value['kind']),
        'mealPlanCode': value['mealPlanCode'],
        'mealPlanName': value['mealPlanName'],
        'images': value['images'] == null ? undefined : ((value['images'] as Array<any>).map(TravelineResourceDtoToJSON)),
        'status': TravelineEntityStateDtoToJSON(value['status']),
        'vat': TravelineVatDtoToJSON(value['vat']),
    };
}

